module.exports = __webpack_public_path__ + "img/0137e53.png";